export const parseLocalDate = (dateValue) => {
  if (!dateValue) return null;

  const datePart = String(dateValue).split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);

  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day);
};

export const formatLocalDate = (dateValue, locale = 'es-MX') => {
  const date = parseLocalDate(dateValue);
  return date ? date.toLocaleDateString(locale) : '';
};
